import { createActionsHook } from 'src/lib/sweetState';

import { BriefsStore } from './BriefsStore';

export const useBriefsActions = createActionsHook(BriefsStore);
